import { Component, HostListener, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { Title } from "@angular/platform-browser";

import * as moment from "moment";
import * as tz from "moment-timezone";

declare var jsonToCSV;
@Component({
  selector: "app-reports",
  templateUrl: "./reports.page.html",
  styleUrls: ["./reports.page.scss"],
})
export class ReportsPage implements OnInit {
  flags: any;
  file: any;
  public isColumnVisible = true;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  constructor(private app: AppService, private http: HttpService, public title: Title) {
    this.checkScreenSize();
    this.flags = {
      loading: false,

      dateSelector: { start: null, end: null },

      search: "",
      query: {
        epochStart: null,
        epochEnd: null,
        userFilter: "all",
        locationFilter: "all",
      },

      editTransaction: null,

      usersList: [],
      sitesList: [],
      sessionsList: [],
      results: [],
    };

    this.getUsers();
    this.getSites();
  }

  openModal(m, params) {
    this.flags.modalMode = m;

    var obj = JSON.parse(JSON.stringify(params));
    obj.conversation = JSON.parse(obj.conversation);

    this.flags.modalData = obj;
  }

  closeModal() {
    this.flags.modalMode = null;
  }

  checkScreenSize() {
    // This ensures that on larger screens, the visibility is handled automatically,
    // but on smaller screens, the column remains visible unless toggled.
    if (window.innerWidth >= 768) {
      this.isColumnVisible = true; // Always visible on larger screens
    } else {
      // Do not automatically hide on mobile; respect the current toggle state
      // Remove or comment out this line if you want it always visible when reloading the page on mobile:
      // this.isColumnVisible = false;
    }
  }

  toggleColumn() {
    if (window.innerWidth < 768) {
      // Change 768 to your desired breakpoint for smaller screens
      this.isColumnVisible = !this.isColumnVisible;
    }
  }

  getUsers() {
    this.http
      .apiGet(
        "user_access/company_id/" +
          this.app.sysData.company_id +
          "?join=user_accounts,cid,cid,id:first_name:last_name:email",
        {}
      )
      .then((data) => {
        console.log("user list", data);
        this.flags.usersList = data.data;
      });
  }

  getSites() {
    this.http.apiGet("company_sites/company_id/" + this.app.sysData.company_id, null).then((data) => {
      console.log("get sites", data.data);
      this.flags.sitesList = data.data;
    });
  }

  calcEpoch() {
    var start = this.flags.dateSelector.start;
    var end = this.flags.dateSelector.end;

    this.flags.query.epochStart = new Date(start).getTime();
    this.flags.query.epochEnd = new Date(end).getTime();

    console.log(this.flags.query);

    if (this.flags.query.epochStart && this.flags.query.epochEnd) {
      this.getData();
    }
  }

  getData() {
    this.flags.loading = true;
    this.http
      .apiGet(
        "archives/company_id/" +
          this.app.sysData.company_id +
          "?search=" +
          ":epoch_open,ge," +
          this.flags.query.epochStart +
          ",and" +
          ":epoch_open,le," +
          this.flags.query.epochEnd +
          ",and" +
          "&orderby=epoch_open&limit=20",
        null
      )
      .then((data) => {
        console.log(data.data);

        var obj = data.data;
        for (var i in obj) {
          //calc ticket duration
          obj[i].duration = Math.round((obj[i].epoch_closed - obj[i].epoch_open) / 60000);

          //attach user details
          var user = this.flags.usersList.find((element) => element.join_id == obj[i].user_id);
          obj[i].user_email = user.join_email;
          obj[i].user_first_name = user.join_first_name;
          obj[i].user_last_name = user.join_last_name;

          //attach site details
          var site = this.flags.sitesList.find((element) => element.id == obj[i].site_id);
          obj[i].site_name = site.name;
        }

        this.flags.sessionsList = obj;
        this.searchTickets();
        this.flags.loading = false;
      });
  }

  resetFilters() {
    this.flags.search = "";
    this.flags.query = {
      epochStart: null,
      epochEnd: null,
      userFilter: "all",
      locationFilter: "all",
    };
  }

  searchTickets() {
    var obj = JSON.parse(JSON.stringify(this.flags.sessionsList));
    var arr: any = [];

    if (!this.flags.search) {
      this.flags.search = "";
    }

    var string = this.flags.search.split(" ");
    for (var q in string) {
      //iterate through query
      var regex = new RegExp(string[q], "i");
      for (var i in obj) {
        if (
          (obj[i].name && obj[i].name.search(regex) != -1) ||
          (obj[i].id && obj[i].id.toString().search(regex) != -1) ||
          (obj[i].source_type && obj[i].source_type.search(regex) != -1)
        ) {
          //if filters are off
          if (this.flags.query.userFilter == "all" && this.flags.query.locationFilter == "all") {
            arr.push(obj[i]);
          }

          //if user filtered
          else if (
            this.flags.query.userFilter != "all" &&
            this.flags.query.locationFilter == "all" &&
            this.flags.query.userFilter == obj[i].user_id
          ) {
            arr.push(obj[i]);
          }

          //if locatinon filtered
          else if (
            this.flags.query.userFilter == "all" &&
            this.flags.query.locationFilter != "all" &&
            this.flags.query.locationFilter == obj[i].site_id
          ) {
            arr.push(obj[i]);
          }

          //if both filtered
          else if (
            this.flags.query.userFilter != "all" &&
            this.flags.query.locationFilter != "all" &&
            this.flags.query.userFilter == obj[i].user_id &&
            this.flags.query.locationFilter == obj[i].site_id
          ) {
            arr.push(obj[i]);
          }
        }
      }
    }

    console.log("FORMATTED DATA", obj);
    this.flags.results = arr;
  }

  export() {
    var obj = JSON.stringify(this.flags.results);
    var name = "Arii Export (" + this.flags.dateSelector.start + " to " + this.flags.dateSelector.end + ") ";

    jsonToCSV(name, obj);
  }

  ngOnInit() {
    this.title.setTitle("Reports");
  }
}
